export var CreditBureauValidator = function CreditBureauValidator(value, param) {
  var field = param.field;
  var radioBtn = document.querySelectorAll("input[name='" + field + "']");
  var status = false;

  for (var i = 0; i < radioBtn.length; i++) {
    if (radioBtn[i].checked) {
      status = true;
    }
  }

  if (!status) {
    return {
      status: false,
      msg: 'Alege o opțiune'
    };
  } else if (value == 'da') {
    return {
      status: false,
      msg: 'Creditul se acordă persoanelor fără restanțe la Biroul de Credit'
    };
  } else {
    return {
      status: true,
      msg: ''
    };
  }
};
export var TotalEmploymentValidator = function TotalEmploymentValidator(value, param) {
  var field = param.field,
      provider = param.provider;
  var radioBtn = document.querySelectorAll("input[name='" + field + "']");
  var status = false;

  for (var i = 0; i < radioBtn.length; i++) {
    if (radioBtn[i].checked) {
      status = true;
    }
  }

  if (!status) {
    return {
      status: false,
      msg: 'Alege o opțiune'
    };
  }

  if (provider) {
    switch (provider) {
      case 'ING Bank':
        if (value == 'mai puțin de 1 an') {
          return {
            status: false,
            msg: 'Creditul se acordă doar persoanelor cu vechime în muncă mai mare de 1 an'
          };
        }

        break;
    }
  }

  return {
    status: true,
    msg: ''
  };
};
export var CurrentEmploymentValidator = function CurrentEmploymentValidator(value, param) {
  var field = param.field,
      provider = param.provider;
  var radioBtn = document.querySelectorAll("input[name='" + field + "']");
  var status = false;

  for (var i = 0; i < radioBtn.length; i++) {
    if (radioBtn[i].checked) {
      status = true;
    }
  }

  if (!status) {
    return {
      status: false,
      msg: 'Alege o opțiune'
    };
  }

  if (provider) {
    switch (provider) {
      case 'ING Bank':
        if (value == 'mai puțin de 6 luni') {
          return {
            status: false,
            msg: 'Creditul se acordă doar persoanelor cu vechime de minim 6 luni la actualul loc de muncă'
          };
        }

        break;

      case 'Telekom Banking':
        if (value == 'mai puțin de 3 luni') {
          return {
            status: false,
            msg: 'Creditul se acordă doar persoanelor cu vechime de minim 3 luni la actualul loc de muncă'
          };
        }

        break;
    }
  }

  return {
    status: true,
    msg: ''
  };
};
export var IncomeField = function IncomeField(value, param) {
  var provider = param.provider,
      product = param.product;

  if (value == '') {
    return {
      status: false,
      msg: 'Completează câmpul'
    };
  } else if (isNaN(value)) {
    return {
      status: false,
      msg: 'Completează doar cifre'
    };
  } else if (value <= 0) {
    return {
      status: false,
      msg: 'Completeaza o sumă pozitivă'
    };
  }

  if (provider) {
    switch (provider) {
      case 'ING Bank':
        if (product) {
          if (product == 'Credit imobiliar' && value < 1500) {
            return {
              status: false,
              msg: 'Venitul minim este de 1.500 lei'
            };
          } else if (product == 'Credit nevoi personale' && value < 1000) {
            return {
              status: false,
              msg: 'Venitul minim este de 1.000 lei'
            };
          }
        }

        break;

      case 'Telekom Banking':
        if (value < 1500) {
          return {
            status: false,
            msg: 'Venitul minim este de 1.500 lei'
          };
        }

        break;
    }
  }

  return {
    status: true,
    msg: ''
  };
};